// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 {
  padding: 0;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G img {
  width: 120px;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G p {
  margin-left: 20px;
  font-size: 16px;
  color: #00377c;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_nav__SwbK5 {
  align-items: center;
  --bs-nav-link-color: #00377c;
  --bs-nav-link-hover-color: #d71921;
  --bs-navbar-active-color: #d71921;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_nav__SwbK5 a::after {
  display: none;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_dropdown__3hPl5 .HeaderBlue_dropdownBtn__FF95q {
  --bs-btn-bg: #1b51e3;
  --bs-btn-border-color: none;
  --bs-btn-hover-border-color: none;
  --bs-btn-active-border-color: none;
  --bs-btn-disabled-border-color: none;
  --bs-btn-border-radius: 20px;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_dropdown__3hPl5 .HeaderBlue_dropdownMenu__YqE2g {
  --bs-dropdown-min-width: 0;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0;
  --bs-dropdown-border-radius: 20px;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_dropdown__3hPl5 .HeaderBlue_dropdownMenu__YqE2g .HeaderBlue_dropdownItem__x7WaG:hover {
  border-radius: 20px;
}
.HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveDropdown__bmvjv {
  display: none;
}

@media (max-width: 991px) {
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_dropdown__3hPl5 {
    display: none;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveBtn__JXWi6 {
    display: flex;
    align-items: center;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveBtn__JXWi6 .HeaderBlue_adaptiveDropdown__bmvjv {
    display: block;
    margin-right: 10px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveBtn__JXWi6 .HeaderBlue_adaptiveDropdown__bmvjv .HeaderBlue_dropdownBtn__FF95q {
    --bs-btn-bg: #1b51e3;
    --bs-btn-border-color: none;
    --bs-btn-hover-border-color: none;
    --bs-btn-active-border-color: none;
    --bs-btn-disabled-border-color: none;
    --bs-btn-border-radius: 20px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveBtn__JXWi6 .HeaderBlue_adaptiveDropdown__bmvjv .HeaderBlue_dropdownMenu__YqE2g {
    --bs-dropdown-min-width: 0;
    --bs-dropdown-padding-x: 0;
    --bs-dropdown-padding-y: 0;
    --bs-dropdown-border-radius: 20px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveBtn__JXWi6 .HeaderBlue_adaptiveDropdown__bmvjv .HeaderBlue_dropdownMenu__YqE2g .HeaderBlue_dropdownItem__x7WaG:hover {
    border-radius: 20px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_adaptiveBtn__JXWi6 .HeaderBlue_toggleMenu__F573l {
    background: #fff;
  }
}
@media (max-width: 768px) {
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G img {
    width: 100px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G p {
    font-size: 14px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_nav__SwbK5 {
    font-size: 14px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_dropdown__3hPl5 .HeaderBlue_dropdownBtn__FF95q {
    font-size: 14px;
  }
}
@media (max-width: 500px) {
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G img {
    width: 90px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G p {
    font-size: 12px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_nav__SwbK5 {
    font-size: 12px;
  }
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_dropdown__3hPl5 .HeaderBlue_dropdownBtn__FF95q {
    font-size: 12px;
  }
}
@media (max-width: 431px) {
  .HeaderBlue_root__fbu25 .HeaderBlue_navbar__XFcXo .HeaderBlue_navbarBrand__shGY7 .HeaderBlue_LogoTitleBlock__XdZ0G p {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/HeaderBlue/HeaderBlue.module.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;EACA,wBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAGQ;EACE,YAAA;AADV;AAIQ;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAFV;AAOI;EACE,mBAAA;EACA,4BAAA;EACA,kCAAA;EACA,iCAAA;AALN;AAQQ;EACE,aAAA;AANV;AAYM;EACE,oBAAA;EACA,2BAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4BAAA;AAVR;AAaM;EACE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,iCAAA;AAXR;AAcU;EACE,mBAAA;AAZZ;AAkBI;EACE,aAAA;AAhBN;;AAqBA;EAGM;IACE,aAAA;EApBN;EAuBI;IACE,aAAA;IACA,mBAAA;EArBN;EAuBM;IACE,cAAA;IACA,kBAAA;EArBR;EAuBQ;IACE,oBAAA;IACA,2BAAA;IACA,iCAAA;IACA,kCAAA;IACA,oCAAA;IACA,4BAAA;EArBV;EAwBQ;IACE,0BAAA;IACA,0BAAA;IACA,0BAAA;IACA,iCAAA;EAtBV;EAyBY;IACE,mBAAA;EAvBd;EA6BM;IACE,gBAAA;EA3BR;AACF;AAiCA;EAKU;IACE,YAAA;EAnCV;EAsCQ;IACE,eAAA;EApCV;EA0CE;IACE,eAAA;EAxCJ;EA4CI;IACE,eAAA;EA1CN;AACF;AA+CA;EAKU;IACE,WAAA;EAjDV;EAoDQ;IACE,eAAA;EAlDV;EAuDI;IACE,eAAA;EArDN;EAyDM;IACE,eAAA;EAvDR;AACF;AA6DA;EAKU;IACE,aAAA;EA/DV;AACF","sourcesContent":[".root {\n  .navbar {\n    --bs-navbar-padding-x: 0;\n    --bs-navbar-padding-y: 0;\n\n    .navbarBrand {\n      padding: 0;\n\n      .LogoTitleBlock {\n        img {\n          width: 120px;\n        }\n\n        p {\n          margin-left: 20px;\n          font-size: 16px;\n          color: #00377c;\n        }\n      }\n    }\n\n    .nav {\n      align-items: center;\n      --bs-nav-link-color: #00377c;\n      --bs-nav-link-hover-color: #d71921;\n      --bs-navbar-active-color: #d71921;\n\n      a {\n        &::after {\n          display: none;\n        }\n      }\n    }\n\n    .dropdown {\n      .dropdownBtn {\n        --bs-btn-bg: #1b51e3;\n        --bs-btn-border-color: none;\n        --bs-btn-hover-border-color: none;\n        --bs-btn-active-border-color: none;\n        --bs-btn-disabled-border-color: none;\n        --bs-btn-border-radius: 20px;\n      }\n\n      .dropdownMenu {\n        --bs-dropdown-min-width: 0;\n        --bs-dropdown-padding-x: 0;\n        --bs-dropdown-padding-y: 0;\n        --bs-dropdown-border-radius: 20px;\n\n        .dropdownItem {\n          &:hover {\n            border-radius: 20px;\n          }\n        }\n      }\n    }\n\n    .adaptiveDropdown {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .navbar {\n      .dropdown {\n        display: none;\n      }\n\n      .adaptiveBtn {\n        display: flex;\n        align-items: center;\n\n        .adaptiveDropdown {\n          display: block;\n          margin-right: 10px;\n\n          .dropdownBtn {\n            --bs-btn-bg: #1b51e3;\n            --bs-btn-border-color: none;\n            --bs-btn-hover-border-color: none;\n            --bs-btn-active-border-color: none;\n            --bs-btn-disabled-border-color: none;\n            --bs-btn-border-radius: 20px;\n          }\n\n          .dropdownMenu {\n            --bs-dropdown-min-width: 0;\n            --bs-dropdown-padding-x: 0;\n            --bs-dropdown-padding-y: 0;\n            --bs-dropdown-border-radius: 20px;\n\n            .dropdownItem {\n              &:hover {\n                border-radius: 20px;\n              }\n            }\n          }\n        }\n\n        .toggleMenu {\n          background: #fff;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    .navbar {\n      .navbarBrand {\n        .LogoTitleBlock {\n          img {\n            width: 100px;\n          }\n\n          p {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    .nav {\n      font-size: 14px;\n    }\n\n    .dropdown {\n      .dropdownBtn {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .root {\n    .navbar {\n      .navbarBrand {\n        .LogoTitleBlock {\n          img {\n            width: 90px;\n          }\n\n          p {\n            font-size: 12px;\n          }\n        }\n      }\n\n      .nav {\n        font-size: 12px;\n      }\n\n      .dropdown {\n        .dropdownBtn {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 431px) {\n  .root {\n    .navbar {\n      .navbarBrand {\n        .LogoTitleBlock {\n          p {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `HeaderBlue_root__fbu25`,
	"navbar": `HeaderBlue_navbar__XFcXo`,
	"navbarBrand": `HeaderBlue_navbarBrand__shGY7`,
	"LogoTitleBlock": `HeaderBlue_LogoTitleBlock__XdZ0G`,
	"nav": `HeaderBlue_nav__SwbK5`,
	"dropdown": `HeaderBlue_dropdown__3hPl5`,
	"dropdownBtn": `HeaderBlue_dropdownBtn__FF95q`,
	"dropdownMenu": `HeaderBlue_dropdownMenu__YqE2g`,
	"dropdownItem": `HeaderBlue_dropdownItem__x7WaG`,
	"adaptiveDropdown": `HeaderBlue_adaptiveDropdown__bmvjv`,
	"adaptiveBtn": `HeaderBlue_adaptiveBtn__JXWi6`,
	"toggleMenu": `HeaderBlue_toggleMenu__F573l`
};
export default ___CSS_LOADER_EXPORT___;
